import { findPayoutTicketAddress } from "@metaplex-foundation/mpl-fixed-price-sale";
import { Connection } from "@solana/web3.js";
import { toPubkey } from "sdk/share";
import { Wallet } from "wallet";

export const isSaleWithdrawn = async ({
  connection,
  marketKey,
  wallet,
}: {
  connection: Connection;
  marketKey: string;
  wallet: Wallet;
}) => {
  const [payoutTicket] = await findPayoutTicketAddress(
    toPubkey(marketKey),
    wallet.publicKey
  );

  const payoutAccount = await connection.getAccountInfo(payoutTicket);

  return Boolean(payoutAccount);
};
